// Module
var code = " <record-form-view fields=\"editController.formFields\" model=\"editController.contract\" title=\"Gaming Contract Master Agreement Edit\" on-submit=\"editController.submit(formViewController)\" on-cancel=\"editController.cancel(formViewController)\"></record-form-view> ";
// Exports
export default code;